import { app } from '../../app.module'
app
  // 一括タグ管理モーダルを開くボタン
  .directive('batchTagModalButton', () => {
    return {
      restrict: 'E',
      template: require('./batch-tag-modal-button.pug')(),
      controller: function ($rootScope, $scope, $mdDialog) {
        // タグボタンをクリックした際の処理
        $scope.showModal = function () {
          // モーダル用のスコープを新規に作成し、モーダル内で使用するパラメーターを格納
          const modalScope: {
            tagType: string
            snsType: string
            selectedIds: [string]
          } = $rootScope.$new()

          modalScope.tagType = $scope.tagType
          // SNS種別
          modalScope.snsType = $scope.snsType
          // 選択されたID
          modalScope.selectedIds = $scope.selectedIds
          // モーダルを表示する。閉じた場合は変更を反映するため、テーブルをリロードする
          $mdDialog.show({
            template: require('../batch-tag-modal/batch-tag-modal.pug')(),
            scope: modalScope,
            clickOutsideToClose: true,
            onRemoving: function () {
              $scope.$emit('reloadTable')
            },
          })
        }
      },
    }
  })
